import {QuestionItem} from './questionitem';

export class QuestionAnswer extends QuestionItem {

  answerId: number;

}



// WEBPACK FOOTER //
// ./src/models/questionanswer.ts